
import ExecutorTaskNotFoundSvgComponent from '../../assets/svg-components/not-found/executor-task';
import './index.scss';

export default function ViewLogNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          <div className="not-found-image img-fluid not-found-image-executor-task">
            <ExecutorTaskNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No record found for selected timeframe or filters.</p>
        </div>
      </div>
    </>
  );
}
